/** @jsxImportSource @emotion/react */

import {
  Button,
  Card,
  Modal,
  Typography,
  useTheme,
} from '@quickbit/qb-design-system';
import { useState } from 'react';
import { JsonDiff } from 'components';
import { KybChange } from 'tabs/Merchants/types';

interface Props {
  changes: KybChange[];
}

export const KybChangelog = ({ changes }: Props) => {
  const [show, setShow] = useState(false);
  const { spacing, palette, shape } = useTheme();
  return (
    <Card>
      <Button text="Show changelog" onClick={() => setShow(!show)} />
      {show && (
        <Modal title="Changelog" closeModal={() => setShow(false)}>
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              gap: spacing.xxs,
              maxHeight: '80vh',
              overflow: 'scroll',
            }}
          >
            {changes.map((c, idx) => (
              <Card key={idx}>
                <div
                  css={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: spacing.xxxs,
                  }}
                >
                  <Typography>{c.changedBy}</Typography>
                  <Typography>{c.created.toLocaleString()}</Typography>
                </div>
                <div
                  css={{
                    backgroundColor: palette.grey.x100,
                    borderRadius: shape.borderRadius,
                    padding: spacing.xxxs,
                  }}
                >
                  <JsonDiff
                    oldString={
                      idx + 1 >= changes.length ? '{}' : changes[idx + 1].state
                    }
                    newString={c.state}
                    noDiffText="No KYB changes"
                  />
                </div>
              </Card>
            ))}
          </div>
        </Modal>
      )}
    </Card>
  );
};
